import { useMemo } from 'react';
import { CreativeTemplatesEntities } from '../constants';
import { getCallToActionTextAssets } from '../utils/callToActionTextAssets';
import { useCreativeTemplatesBuilderStore } from 'stores/CreativeTemplatesBuilderStore';
import { useTextAssetsBuilderStore } from 'stores/TextAssetsBuilderStore';

const { IMAGES, CTAs } = CreativeTemplatesEntities;

export const useTextAssets = () => {
  const store = useCreativeTemplatesBuilderStore();
  const textAssetStore = useTextAssetsBuilderStore();

  const activeTabKey = store.activeTab.key;

  const newTextAsset = useMemo(
    () => textAssetStore.getTextAsset(activeTabKey),
    [activeTabKey, textAssetStore.getTextAssets]
  );

  const textAssets = useMemo(() => {
    if (!store.articleGroupAssets || activeTabKey === IMAGES) {
      return;
    }

    if (activeTabKey === CTAs) {
      return getCallToActionTextAssets(store.campaignObjective);
    }

    return store.articleGroupAssets[activeTabKey];
  }, [
    store.activeTab,
    store.articleGroup,
    store.campaignObjective,
    store.articleGroup?.headlines,
    store.articleGroup?.postTexts,
    store.articleGroup?.descriptions
  ]);

  return {
    textAssets,
    activeTabKey,
    newTextAsset
  };
};
